var map = {
	"./Hummourr.jpg": 4785,
	"./Humour.jpg": 9266,
	"./Mussee.jpg": 2220,
	"./Spectt.jpg": 9523,
	"./alfgrev.jpg": 2377,
	"./statuu.jpg": 8402
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 383;